import { Card, CardContent } from '@mui/material';
import { MprcContainer } from 'components';
import { TrainingType } from 'generated/CoreApi_v1';
import React from 'react';
import { CourseEnrollmentViewSteps } from 'views/lms/student/EnrollmentView/Course/CourseEnrollmentViewSteps';
import { TrainingViewRightPanel } from 'views/lms/student/TrainingView/TrainingViewRightPanel';
import { useEnrollmentViewContext } from '..';

/////////////////////////////////////////////////////////////////////////////////////

export const CourseEnrollmentViewRightPanel: React.FC = () => {

    const { enrollment, openRightPanel } = useEnrollmentViewContext();

    return (
        <>
            {enrollment.trainingType === TrainingType.Course && !enrollment.course!.singleComponent &&
                <CourseEnrollmentViewSteps variant="vertical" />
            }
            <MprcContainer>
                <Card elevation={openRightPanel ? 0 : undefined}>
                    <CardContent sx={openRightPanel ? { p: 0 } : {}}>
                        <TrainingViewRightPanel trainingId={enrollment.trainingId} />
                    </CardContent>
                </Card>
            </MprcContainer>
        </>
    );
};
